// extracted by mini-css-extract-plugin
export var deliveryRow = "_mx-a";
export var fixedHeight = "_mx-4";
export var freightLogo = "_mx-9";
export var fullWidth = "_mx-3";
export var priceColumn = "_mx-5";
export var radioSelected = "_mx-7";
export var radioUnselected = "_mx-6";
export var selectedOption = "_mx-2";
export var selectedOptionContainer = "_mx-1";
export var selection = "_mx-0";
export var tallSkeletonText = "_mx-8";